<template>
  <n-carousel
    class="carousel-user-center"
    effect="card"
    show-arrow
    :show-dots="false"
    :slides-per-view="1"
    :centered-slides="true"
    :prev-slide-style="list.length > 1 ? prevSlideStyle : prevSlideStyle1"
    :next-slide-style="list.length > 1 ? nextSlideStyle : nextSlideStyle1"
  >
    <n-carousel-item v-for="(item, index) in list" :key="index" @click="clickItem(item)">
      <div class="item">
        <div class="item-top">
          <div class="item-top-icon">
            <UserCenterIconTypeUpdate v-if="item?.type === 1" />
            <UserCenterIconTypePopular v-if="item?.type === 2" />
            <UserCenterIconTypeGrowth v-if="item?.type === 3" />
          </div>
          <div class="item-top-title">
            {{
              item?.type === 1
                ? 'DTS Update'
                : item?.type === 2
                  ? 'Popular Topic'
                  : 'Personal Growth'
            }}
          </div>
        </div>
        <div class="item-content" v-html="xssInstance.process(item?.message)"></div>
        <div class="item-footer">
          <div class="item-footer-time">{{ timestampToTime(item?.releaseTime, 'time') }}</div>
          <div class="item-footer-delete" @click.stop="deleteNotification(item)">
            <SVG.UserCenterDelete />
          </div>
        </div>
      </div>
    </n-carousel-item>
    <template #arrow="{ prev, next }">
      <div class="arrow">
        <button type="button" class="custom-arrow--left" @click="prev">
          <SVG.UserCenterArrowPrev />
        </button>
        <button type="button" class="custom-arrow--right" @click="next">
          <SVG.UserCenterArrowNext />
        </button>
      </div>
    </template>
  </n-carousel>
</template>

<script setup lang="ts">
import { NCarousel } from 'naive-ui';
import SVG from '@dts/shared/src/assets/svg';
import {
  UserCenterIconTypePopular,
  UserCenterIconTypeGrowth,
  UserCenterIconTypeUpdate,
} from '@dts/shared/src/assets/svg/UserCenter';
import { timestampToTime } from '@/utils/baseTool';
import xssInstance from '@dts/shared/src/utils/xss';
defineProps({
  list: { type: Array, default: () => [] },
});
const emits = defineEmits(['openNotification', 'deleteNotification']);
const clickItem = (item: any) => {
  // emits('openNotification', item);
};
const deleteNotification = (item: any) => {
  emits('deleteNotification', item);
};

const prevSlideStyle = {
  transform: 'translateX(-3.25rem) translateZ(-1rem)',
  opacity: 1,
};
const prevSlideStyle1 = {
  transform: 'translateX(0rem) translateZ(0)',
  opacity: 1,
};
const nextSlideStyle = {
  transform: 'translateX(-2.49rem) translateZ(-1rem)',
  opacity: 1,
};
const nextSlideStyle1 = {
  transform: 'translateX(-3.23rem) translateZ(0)',
  opacity: 1,
};
</script>

<style scoped lang="scss">
.carousel {
  margin-left: 0 auto;
  position: relative;
}
.item {
  width: 5.74rem;
  height: 2.4rem;
  background-color: #ffffff;
  box-shadow: 0.04rem 0.04rem 0.4rem 0rem #0000001a;
  padding: 0.15rem;
  .item-top {
    width: 100%;
    height: 0.24rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .item-top-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 0.24rem;
        height: 0.24rem;
      }
    }
    .item-top-title {
      margin-left: 0.12rem;
      font-family: BMWTypeNext, serif;
      font-size: 0.16rem;
      font-weight: 700;
      line-height: 0.2168rem;
      text-align: left;
    }
  }
  .item-content {
    margin-top: 0.16rem;
    height: 1.33rem;
    font-family: BMWTypeNext, serif;
    font-size: 0.14rem;
    font-weight: 300;
    text-align: left;
    overflow: hidden;
  }
  .item-footer {
    width: 100%;
    height: 0.2rem;
    margin-top: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .item-footer-time {
      font-family: BMWTypeNext, serif;
      font-size: 0.14rem;
      font-weight: 300;
      line-height: 0.1897rem;
      text-align: left;
    }
    .item-footer-delete {
      cursor: pointer;
      svg {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
}
.arrow {
  button {
    width: 0.36rem;
    height: 0.36rem;
    border-radius: 100%;
    border: none;
    background-color: #ffffff99;

    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 20px 0px #0e16271a;

    box-shadow: 0px 4px 4px 0px #ffffff40 inset;

    svg {
      width: 0.166rem;
      height: 0.166rem;
    }
    top: 50%;
    transform: translateY(-50%);

    cursor: pointer;
    &:hover {
      background-color: #ecebeb;
    }
  }

  .custom-arrow--left {
    position: absolute;
    left: 0;
  }
  .custom-arrow--right {
    position: absolute;
    right: 0;
  }
}
</style>
<style lang="scss">
.carousel-user-center {
  .n-carousel__slide--current {
    margin-left: 0.36rem;
  }
}
</style>
